import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequest } from '../../../common/Common';
import { filterNonItemList } from './util';
import { TARGET_YEAR_API } from '../../../common/data';

const initialState = {
  isRender: false,
  reload: -1,
  dataList: [],
  //공제 불가 항목
  nonItemList: [],
  //원본데이터
  originalDataList: [],
};

//항목선택 불러오기
export const getItemSelectionInfo = createAsyncThunk(
  'itemSelection/getItemSelectionInfo',
  async () => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S4`);
    return response;
  },
);

//항목선택 저장
export const updateItemSelectionInfo = createAsyncThunk(
  'itemSelection/updateItemSelectionInfo',
  async data => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S4CheckUpdate`, data);
    return response;
  },
);

export const updateHtm159 = createAsyncThunk('itemSelection/S4_159', async () => {
  const response = await APIRequest(`/${TARGET_YEAR_API}/S4_159`);
  return response;
});

const itemSelectionSlice = createSlice({
  name: 'itemSelection',
  initialState,
  reducers: {
    confirmDelete: (state, action) => {
      const { index } = action.payload;
      state.dataList = state.dataList.filter((_, idx) => idx !== index);
    },

    resetItemSelectionState: () => initialState, // 상태 리셋 액션 추가
  },
  extraReducers: builder => {
    builder.addCase(getItemSelectionInfo.pending, state => {
      // state.dataList = [];
      // state.nonItemList = [];
      state.isRender = false;
    });
    builder.addCase(getItemSelectionInfo.fulfilled, (state, action) => {
      console.log('항목선택 리스트 >>', action.payload);
      state.dataList = action.payload;
      state.nonItemList = filterNonItemList(action.payload);
      state.isRender = true;
    });

    builder.addCase(updateItemSelectionInfo.fulfilled, (state, action) => {
      console.log('항목선택 저장 성공 >>', action.payload);
      const { resultCode } = action.payload;
      if (resultCode === 'OK') {
        state.reload = Math.random();
      }
    });
  },
});

export const { confirmDelete, resetItemSelectionState } = itemSelectionSlice.actions;
export default itemSelectionSlice.reducer;
